import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import chairImage from "../images/chair-image.jpg";
import blueprintImage from "../images/pointing-to-blueprints.jpg";
import constructionImage from "../images/construction-site-plans.jpg";
import interiorImage from "../images/interior.jpg";
import fitoutImage from "../images/fitout.jpg";
import mothminkImage from "../images/mothmink.jpg";

function Home() {
  return (
    <>
      <Container
        fluid
        style={{
          minHeight: "80vh",
        }}
        className="App"
      >
        <Row>
          <Col className="App-homepage-bg"></Col>
        </Row>
        <Row className="App-section App-bg-color-dark">
          <Col className="App-section-col">
            <h1
              className="tinos-regular"
              style={{
                paddingBottom: "20px",
              }}
            >
              urban group
            </h1>
            <div className="quattrocento-sans-bold">
              URBAN GROUP One-Stop-Property-Shop is a company formed with many
              years of experience in the construction sector in Ireland and the
              UK, with a reputation for quality, innovation and professionalism.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We are a fast moving, ever expanding, modern company offering
              professional architectural design and building services as well as
              supplying exclusive furniture products. We undertake projects of
              all sizes and provide all the services people need, to both the
              residential and commercial sectors, all carried out by qualified
              professionals.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Urban Group are a one stop shop who can cater for all your
              property requirements, from architectural & interior design,
              building construction & fit out, to furniture supply and property
              staging, providing a highly tailored and seamless
              concept-to-completion experience.
            </div>
          </Col>
        </Row>
        {/* Hibernia card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-bg-color-dark">
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={chairImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="furniturePhoto"
                />
              </Col>
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  Hibernia Luxury Furniture
                </h2>
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  href="https://www.hibernialuxuryfurniture.com/"
                  target="_blank"
                  variant="outline-light"
                >
                  Visit our store
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Architecture Card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-flex-reverse App-bg-color-dark">
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  architecture
                </h2>
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  href="/architecture"
                  variant="outline-light"
                >
                  Find out more
                </Button>
              </Col>
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={blueprintImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="blueprintImage"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Construction Card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-bg-color-dark">
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={constructionImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="constructionImage"
                />
              </Col>
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  construction
                </h2>
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  href="/construction"
                  variant="outline-light"
                >
                  Find out more
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Interior Design Card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-flex-reverse App-bg-color-dark">
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  interior design
                </h2>
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  href="/interiordesign"
                  variant="outline-light"
                >
                  Find out more
                </Button>
              </Col>
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={interiorImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="interiorImage"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Fit out Card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-bg-color-dark">
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={fitoutImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="fitoutImage"
                />
              </Col>
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  fit out
                </h2>
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  href="/fitout"
                  variant="outline-light"
                >
                  Find out more
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Moth and Mink Card */}
        <Row className="App-bg-color-light">
          <Col className="App-section-col">
            <Row className="App-flex-reverse App-bg-color-dark">
              <Col className="App-card-col-text">
                <h2
                  className="tinos-regular"
                  style={{
                    padding: "20px",
                  }}
                >
                  MOTH+Mink
                </h2>
                <div className="quattrocento-sans-bold">
                  MOTH+Mink have created a trove of intensely rich decor pieces
                  for your interior spaces, each and every one having been mined
                  from our years of architectural and interior design.
                </div>
                <br />
                <Button
                  style={{
                    marginBottom: "20px",
                    fontFamily: "Quattrocento Sans, sans-serif",
                    fontWeight: "700",
                  }}
                  variant="outline-light"
                  href="https://www.mothandmink.com/"
                  target="_blank"
                >
                  Visit MOTH + Mink
                </Button>
              </Col>
              <Col className="App-card-col-image" style={{ padding: "0" }}>
                <img
                  src={mothminkImage}
                  style={{ width: "100%", height: "auto" }}
                  alt="mothminkImage"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Home;
